import { render, staticRenderFns } from "./FlashCardFooter.vue?vue&type=template&id=ff87407c&"
import script from "@/scripts/FlashCard/FlashCardDetail/components/FlashCardFooter/FlashCardFooter?vue&type=script&lang=js&"
export * from "@/scripts/FlashCard/FlashCardDetail/components/FlashCardFooter/FlashCardFooter?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports